import { render, staticRenderFns } from "./ArchivedRecipes.vue?vue&type=template&id=758c03eb&"
import script from "./ArchivedRecipes.vue?vue&type=script&lang=js&"
export * from "./ArchivedRecipes.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedRecipes.vue?vue&type=style&index=0&id=758c03eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports